import { GET_TEAM, SENT_ADD_USER } from '../actions/team';

const initialState = {
  teamData: [],
  teamTotalPage: 1,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_TEAM.SUCCESS: {
      return {
        ...state,
        teamData: payload.data.data.response,
        teamTotalPage: payload.data.data._meta.pageCount,
      };
    }

    default:
      return state;
  }
};

export default reducer;
